import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";

const firebaseConfig = {
  apiKey: "AIzaSyBCSH5fGGlfdR0f4nvRXax5yMAYL89inRA",
  authDomain: "mrcook-5a2f1.firebaseapp.com",
  projectId: "mrcook-5a2f1",
  storageBucket: "mrcook-5a2f1.firebasestorage.app",
  messagingSenderId: "158307168766",
  appId: "1:158307168766:web:6d526fc9c715a2c747d0af",
  measurementId: "G-Z79GDDBMMD"
};

// Initialize Firebase
export const app = initializeApp(firebaseConfig);
export const analytics = getAnalytics(app);
export const auth = getAuth(app);
export const db = getFirestore(app);
